import { useEffect, useState } from "react";
import { AuthModal } from "../index";
import { Button, EnterCode } from "shared";
import "./SuccessorEntryCode.scss";
import { useVerifySuccessorSectionCode } from "hooks/successors/VerifySectionCodeHook";
import { useResendSuccessorSectionCode } from "hooks/successors/ResendSectionCodeHook";

interface SuccessorEntryCodeProps {
  email?: string;
  onVerified?: () => void;
}

const SuccessorEntryCode: React.FC<SuccessorEntryCodeProps> = ({
  email,
  onVerified,
}) => {
  const [code, setCode] = useState<string[]>(["", "", "", ""]);
  const isComplete = code.every((c) => c !== "");

  const { mutate, isPending } = useVerifySuccessorSectionCode({
    onSuccess: () => {
      onVerified?.();
    },
  });
  const { mutate: resendCode, isPending: resendPending } =
    useResendSuccessorSectionCode();

  useEffect(() => {
    document.getElementById("code-input-0")?.focus();
  }, []);

  const handleConfirm = () => {
    if (!isComplete || isPending) return;
    mutate({ code: code.join("") });
  };

  return (
    <AuthModal
      heading={"Wprowadź kod dostępu"}
      paragraph={
        <>
          Na podany adres e-mail wysłaliśmy jednorazowy kod weryfikacyjny. Kod
          jest aktywny przez 15 minut. Jeśli wygaśnie, możesz wysłać go
          ponownie.
        </>
      }
    >
      <div className="successor-entry-code">
        <EnterCode code={code} setCode={setCode} />
        <Button
          label={isPending ? "Weryfikacja..." : "Potwierdź"}
          styleType="primary"
          type="button"
          disabled={!isComplete || isPending}
          onClick={handleConfirm}
          className="successor-entry-code__confirm"
        />
        <Button
          label={resendPending ? "Wysyłanie..." : "Wyślij kod ponownie"}
          styleType="strokeBlack"
          type="button"
          onClick={() => resendCode()}
          disabled={resendPending}
        />
      </div>
    </AuthModal>
  );
};

export default SuccessorEntryCode;
